import { render, staticRenderFns } from "./ConvenioDadosDespesaDocumentos.vue?vue&type=template&id=9f6a9446&"
import script from "./ConvenioDadosDespesaDocumentos.vue?vue&type=script&lang=js&"
export * from "./ConvenioDadosDespesaDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports